







































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions } from 'vuex';

// Models
import { CreditCard } from '@/shared/models/creditCard.model';

// Components
import FieldSet from '@/shared/components/field-set.component.vue';
import Input, {
    InputType,
    InputStyle,
} from '@/shared/components/input.component.vue';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';


@Component({
    components: {
        FieldSet,
        Input,
    },
    computed: {
        ...mapGetters({
            currentBudget: 'getCurrentBudgetAcceptance',
            acceptanceFieldError: 'getAcceptanceFieldError',
        }),
    },
    methods: {
        ...mapActions({
            setCurrentBudgetAcceptance: 'setCurrentBudgetAcceptance',
        }),
    },
})
export default class PaymentMethodCard extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop({ default: false }) private readOnly!: boolean;


    private inputType = InputType;
    private currentBudget!: any;
    private setCurrentBudgetAcceptance!: any;
    private acceptanceFieldError!: any;


    @Watch('acceptanceFieldError')
    private watchAcceptanceFieldError(newVal: any, oldVal: any) {
        this.error = Object.assign({}, newVal);
    }


    private created() {
        if ( !this.currentBudget.creditCard ) {
            this.currentBudget.creditCard = new CreditCard();
        }
    }


    private updateCurrentBudgetAcceptance() {
        this.setCurrentBudgetAcceptance(this.currentBudget);
    }

}
